// extracted by mini-css-extract-plugin
module.exports = {"paymentMadeContainer":"PaymentDetailsConfirmed_paymentMadeContainer__3z8jp"};